export default __webpack_public_path__ + "static/media/fundo-ipad.5874062f.svg";